import * as z from "zod";
import { userFacingError } from "../authorization";
import { matchesUrlPattern } from "../connectors/matchesUrlPattern";
import { assertSupplierAvailable } from "../rbac/crossResourceAvailability";
import { mutator } from "./mutator";

export const resolveConnectionClaim = mutator({
  schema: z.object({
    claimId: z.string(),
    connectedAppId: z.string(),
    branchId: z.string().optional(),
  }),
  resolve: {
    claim: { kind: "connectionClaim", from: "claimId" },
    app: { kind: "connectedApp", from: "connectedAppId" },
    targetBranch: { kind: "branch", from: "branchId", optional: true },
  },
  permissions: [
    {
      permission: "space:write",
      scopeId: ({ args }) => args.claim.workflow.spaceId,
    },
    {
      permission: "connected_app:use",
      scopeId: ({ args }) => args.app.id,
    },
  ],
  fn: async ({ tx, args: { claim, app, targetBranch } }) => {
    if (claim.status !== "pending") return;

    if (targetBranch && targetBranch.workflowId !== claim.workflowId) {
      throw userFacingError("Branch not found");
    }

    if (
      claim.targetUrl &&
      !matchesUrlPattern(app.urlPattern, claim.targetUrl)
    ) {
      throw userFacingError(
        "This connector’s URL pattern does not match the claimed URL"
      );
    }

    await assertSupplierAvailable({
      tx,
      tenantId: claim.workflow.tenantId,
      ruleId: "space_uses_connected_apps",
      dependentScopeId: claim.workflow.spaceId,
      supplierScopeId: app.id,
    });

    await tx.mutate.connectionClaims.update({
      id: claim.id,
      status: "resolved",
      connectedAppId: app.id,
      ...(targetBranch ? { branchId: targetBranch.id } : {}),
    });
  },
});
